module.exports = __webpack_public_path__ + "static/media/Otamendi.5432bcd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/images/players/Otamendi.png
// module id = 286
// module chunks = 0